import { render, staticRenderFns } from "./NoMore.vue?vue&type=template&id=58738338&scoped=true&"
import script from "./NoMore.vue?vue&type=script&lang=js&"
export * from "./NoMore.vue?vue&type=script&lang=js&"
import style0 from "./NoMore.vue?vue&type=style&index=0&id=58738338&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58738338",
  null
  
)

export default component.exports